module.exports = __webpack_public_path__ + "static/devops-engineer-professional-e0b3f73feda3f78724a3142a7fb10aa1.png";